export const tableHeaders = [
  {
    label: 'Date and Time',
    value: 'DateCreated',
    canOrderBy: true,
    width: '15%',
  },
  {
    label: 'User',
    value: 'User',
    canOrderBy: false,
    width: '15%',
  },
  {
    label: 'Source',
    value: 'Source',
    canOrderBy: false,
    width: '10%',
  },
  {
    label: 'Record #',
    value: 'Record #',
    canOrderBy: false,
    width: '10%',
  },
  {
    label: 'Type',
    value: 'Type',
    canOrderBy: false,
    width: '10%',
  },
  {
    label: 'Description',
    value: 'Description',
    canOrderBy: false,
    width: '45%',
  },
];
